/**
 * Panier caisse → lignes Pass multi-règles.
 */
import type { Cart, CartItem } from '../../types/transaction';
import type { LoyaltyPassSaleLineInput } from './evaluateSaleRules';

function lineAmountXaf(item: CartItem): number {
  const afterPromo = Math.max(
    0,
    Math.floor((item.finalPrice ?? item.subtotal) - (item.promotionDiscount || 0))
  );
  return afterPromo;
}

export function cartItemToLoyaltyPassSaleLine(
  item: CartItem,
  index: number
): LoyaltyPassSaleLineInput {
  return {
    lineId: item.tempId || `${item.type}_${item.id}_${index}`,
    kind: item.type,
    ...(item.categoryId ? { categoryId: item.categoryId } : {}),
    amountXaf: lineAmountXaf(item),
    qty: item.quantity,
  };
}

export function cartToLoyaltyPassSaleLines(cart: Cart | null | undefined): LoyaltyPassSaleLineInput[] {
  if (!cart?.items?.length) return [];
  return cart.items.map((item, index) => cartItemToLoyaltyPassSaleLine(item, index));
}

/** Somme des remises award (FCFA). */
export function sumLoyaltyPassAwardsDiscount(
  awards: Array<{ discountAmountXaf: number }>
): number {
  return awards.reduce(
    (s, a) => s + Math.max(0, Math.floor(a.discountAmountXaf || 0)),
    0
  );
}
